import {
  MockMap,
} from '@ama-sdk/core';
import {
  AcceptanceRepository,
  BaggageRepository,
  combineCheckInBaggagePolicies,
  combineJourneys,
  ContextualSeatmapDataRepository,
  createMockData,
  createMockDataWithResponse,
  RegulatoryDetailsReplyDataRepository,
} from '@dapi/sdk/spec';
import {
  inhibitedBoardingPassResult,
} from '../../mock/data';
import {
  cancelledAcceptedJourney,
  cancelledJourney,
} from '../../mock/dictionaries';

/**
 * OW 1 Journey
 * Check-in and Retirve Journey 1ADT with Cancelled flight status
 */
export const ow1Journey1AdtCancelledFlightMock: MockMap = {
  generateBoardingPasses: [createMockDataWithResponse(inhibitedBoardingPassResult, 201)],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies().items)],
  getJourneyUnpaidItems: [createMockDataWithResponse(undefined, 404, [{
    code: '10000',
    title: 'No unpaid service',
    type: 'error',
    id: '10000'
  }])],
  getRegulatoryDetails: [createMockData(RegulatoryDetailsReplyDataRepository.DEFAULT)],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201), createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201)],
  retrieveJourneyBaggages: [createMockData([BaggageRepository.DEFAULT])],
  retrieveJourneys: [
    createMockDataWithResponse(combineJourneys([cancelledJourney]).items, 201),
    createMockDataWithResponse(combineJourneys([cancelledAcceptedJourney]).items, 201)
  ],
  retrieveJourney: [],
  retrieveSeatMapsJourneyDriven: [createMockData(ContextualSeatmapDataRepository.DEFAULT)],
  removeTravelersFromJourney: [createMockData({})]
};
